<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <agentVendorShop @select="selectHandler" />

      <el-form-item label="模板ID">
        <el-input
          v-model="formInline.templateid"
          placeholder="请输入模板ID"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSearch"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >设置</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-setting"
          @click="onBatchDisabled(true)"
          :disabled="!multipleSelection.length"
          >批量禁用</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-setting"
          @click="onBatchDisabled(false)"
          :disabled="!multipleSelection.length"
          >批量启用</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <!-- <el-table-column prop="productid" label="产品ID"></el-table-column> -->
      <el-table-column
        prop="sequence"
        width="55"
        label="排序"
      ></el-table-column>

      <el-table-column prop="shopName" label="门店"></el-table-column>
      <el-table-column prop="machineModel" label="机器型号"></el-table-column>

      <el-table-column prop="name" label="产品名称"></el-table-column>
      <el-table-column prop="price" label="价格(元)"></el-table-column>
      <el-table-column prop="description" label="产品描述"></el-table-column>
      <el-table-column label="是否默认">
        <template slot-scope="scope">
          <div>
            <el-tag type="success" v-if="scope.row.isdefault">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否启用">
        <template slot-scope="scope">
          <i
            class="el-icon-check"
            style="color:#67c23a;font-weight:bold;"
            v-if="!scope.row.isdisabled"
          ></i>
          <i
            class="el-icon-close"
            style="color:#e66100;font-weight:bold;"
            v-else
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleDisabled(scope.row.productid, true)"
            v-if="!scope.row.isdisabled"
            >禁用</el-button
          >
          <el-button
            type="text"
            @click="handleDisabled(scope.row.productid, false)"
            v-else
            >启用</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
    <QuickBindDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSearch"
      :editInfo="editInfo"
    />
  </div>
</template>

<script>
// import BindDialog from "./components/bindDialog";
import agentVendorShop from "@/components/layout/agentVendorShop";

import QuickBindDialog from "./components/quickBindDialog";

//import { mapGetters } from "vuex";
export default {
  components: {
    agentVendorShop,
    QuickBindDialog
  },
  data() {
    return {
      formInline: {
        templateid: "",

        agentid: "",
        vendorid: "",
        shopid: "",
        agentName: "",
        vendorName: "",
        shopName: ""
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: [],
      //isCreate: true,
      isDialogShow: false,
      editInfo: null,
      multipleSelection: []
    };
  },

  mounted() {
    this.onSearch();
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.shopid = x.selectedShop.shopid;
    },

    onSearch() {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["获取产品信息"], {
          data: {
            shopid: this.formInline.shopid,
            templateid: this.formInline.templateid,
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize
          }
        }).then(result => {
          this.tableData = result.data;
          this.page.total = result.totalCount;
          this.page.currentPage = result.pageNum;
          resolve();
        });
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSearch();
    },
    onAdd() {
      this.editInfo = null;
      //this.isCreate = true;
      this.isDialogShow = true;
    },
    closeForm() {
      this.isDialogShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDisabled(productid, type) {
      this.$confirm("是否确认操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["设置失效产品"], {
          data: {
            disabled: type,
            productIDs: Array.of(productid)
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSearch();
        });
      });
    },
    onBatchDisabled(type) {
      this.$confirm("是否确认操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let productIDs = this.multipleSelection.map(ele => ele.productid);
        this.$axios(this.$urlMapping["设置失效产品"], {
          data: {
            disabled: type,
            productIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSearch();
        });
      });
    },
    handleEdit(editInfo) {
      console.log(editInfo);
      this.editInfo = editInfo;
      //this.isCreate = false;
      this.isDialogShow = true;
    },

    handleDelete(productInfo) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let productids = [productInfo.productid];
        this.$axios(this.$urlMapping["删除产品"], {
          data: {
            productids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSearch();
        });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
